import { Card, CardContent, CardHeader, Typography } from '@material-ui/core'
import React from 'react'

import { MembershipType, TrialMembershipType } from '../Market/AdvancedSettings'
import { SubTitle } from '../Common/Headers'

const AvailableMemberships = ({
	memberships = [],
	updateMembership,
	updateTrialMembership,
	migrated = true
}) => {
	if (!migrated) {
		return (
			<Card style={{ maxWidth: '1245px' }}>
				<CardHeader title="Available Memberships" />
				<CardContent>
					<Typography variant="body2" color="textSecondary">
						Memberships have not been migrated for this facility yet. Run the market-to-facility
						migration before editing facility memberships.
					</Typography>
				</CardContent>
			</Card>
		)
	}

	return (
		<Card style={{ maxWidth: '1245px' }}>
			<CardHeader title="Available Memberships" />
			<CardContent>
				<SubTitle label="Available Memberships" />
				{(memberships || []).map((membership) =>
					membership.is_trial ? (
						<TrialMembershipType
							key={membership._id}
							membership={membership}
							updateMembership={updateMembership}
							updateTrialMembership={updateTrialMembership}
						/>
					) : (
						<MembershipType
							key={membership._id}
							membership={membership}
							updateMembership={updateMembership}
						/>
					)
				)}
				{(memberships || []).length === 0 && <Typography>No available memberships</Typography>}
			</CardContent>
		</Card>
	)
}

export default AvailableMemberships
